'use es6';

export const BOOKING_STEPS = {
  CHOOSE_TIME: 'chooseTime',
  YOUR_INFO: 'yourInfo',
  PAYMENT: 'payment'
};
export const BOOKING_STEPS_END = {
  SUMMARY: 'summary'
};